import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function MauritiusJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Mauritius as a Jurisdiction"
                subtitle="A Tier-1 International Financial Centre in Africa & the Indian Ocean"
                description="Mauritius has built a strong reputation as a global financial hub, offering a wide range of offshore and onshore financial services. It is regulated by two main authorities: the Financial Services Commission (FSC), overseeing securities, funds, fintech, insurance, and non-banking financial services, and the Bank of Mauritius (BoM), supervising domestic and international banks. Mauritius combines political stability, a robust legal system (based on English & French law), OECD compliance, and over 40 double taxation treaties, making it a preferred hub for funds, investment, and cross-border trade."
                badges={[
                    "Funds & Asset Management",
                    "Forex & Brokerage",
                    "Banking",
                    "Insurance",
                    "Crypto (VASPs)",
                    "Payments & FinTech",
                    "Trusts & Fiduciary"
                ]}
                buttonText="Request a Mauritius Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/mauritius-jurisdiction.png')}
                imageAlt="Mauritius Offshore Financial Hub"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Mauritius?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Tier-1 Offshore IFC",
                                        text: "Highly respected, unlike “light” offshore centers."
                                    },
                                    {
                                        title: "OECD-Compliant",
                                        text: "No blacklist risk; FATF-aligned jurisdiction."
                                    },
                                    {
                                        title: "Gateway Location",
                                        text: "Links Africa, India, and Asia."
                                    },
                                    {
                                        title: "Double Tax Treaties",
                                        text: "40+ DTTs, especially with India and Africa."
                                    },
                                    {
                                        title: "Crypto-Friendly",
                                        text: "One of the first African nations with a dedicated VASP law."
                                    },
                                    {
                                        title: "Robust Banking",
                                        text: "Presence of international banks and private wealth services."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Structures & Services in Mauritius"
                        blocks={[
                            {
                                title: "Banking Licenses",
                                items: [
                                    { text: "Domestic Banking License (local retail & commercial banking)." },
                                    { text: "International Banking License (offshore/private banking)." },
                                    { text: "Regulated by the Bank of Mauritius." }
                                ]
                            },
                            {
                                title: "Brokerage & Investment Dealer Licenses",
                                items: [
                                    { text: "Full Service Investment Dealer: brokerage, market making." },
                                    { text: "Execution Only Dealer: forex & securities without advisory." },
                                    { text: "Investment Adviser: portfolio/fund advisory services." },
                                    { text: "Regulated by the FSC." }
                                ]
                            },
                            {
                                title: "Payments & FinTech Licenses",
                                items: [
                                    { text: "Payment Intermediary Services (PIS) — PSPs, merchant acquiring." },
                                    { text: "E-Money Issuer (EMI) — digital money, e-wallets." },
                                    { text: "FinTech Sandbox License — innovation-friendly model." }
                                ]
                            },
                            {
                                title: "Insurance & Reinsurance Licenses",
                                items: [
                                    { text: "General, Life, Captive, and Reinsurance companies." },
                                    { text: "Insurance brokers and agents." },
                                    { text: "Capital requirements vary: USD 125k–1M." }
                                ]
                            },
                            {
                                title: "Funds & Asset Management",
                                items: [
                                    { text: "Collective Investment Schemes (mutual funds, hedge funds)." },
                                    { text: "Closed-End Funds: private equity, VC funds." },
                                    { text: "CIS Manager & Administrator licenses." },
                                    { text: "Mauritius funds benefit from DTTs and tax neutrality." }
                                ]
                            },
                            {
                                title: "Trusts & Fiduciary Services",
                                items: [
                                    { text: "Trustee Licenses and Management Company (MC) Licenses." },
                                    { text: "Used for estate planning, nominee, and wealth management services." }
                                ]
                            },
                            {
                                title: "Gaming & Gambling",
                                items: [
                                    { text: "Licensed by the Gambling Regulatory Authority (GRA)." },
                                    { text: "Covers casinos, betting, and lotteries." },
                                    { text: "Online gaming is limited compared to Curacao or Seychelles." }
                                ]
                            },
                            {
                                title: "Crypto & Digital Assets (VASPs)",
                                items: [
                                    { text: "Licensed under VAITOS (Virtual Asset & Initial Token Offering Services Act, 2021)." },
                                    { text: "Covers crypto exchanges, wallets, custodians, and token issuance." },
                                    { text: "Capital Requirement: USD 250k–500k." },
                                    { text: "Mauritius is among the most respected crypto hubs globally." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of Mauritius as a Jurisdiction'
                        services={[
                            {
                                title: "Global Reputation",
                                text: "Stronger than Seychelles, Mwali, or Western Sahara."
                            },
                            {
                                title: "Regulatory Credibility",
                                text: "FSC & BoM are respected Tier-1 regulators."
                            },
                            {
                                title: "Banking Stability",
                                text: "Access to international correspondent banking."
                            },
                            {
                                title: "Tax Advantage",
                                text: "Double Tax Treaties plus territorial tax regime for GBCs."
                            },
                            {
                                title: "Ideal for Funds & Crypto",
                                text: "Widely used for hedge funds, PE/VC, and VASPs."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Offshore Advisory in Mauritius'
                        items={[
                            { text: "Company formation (GBCs, Authorised Companies, local entities)." },
                            { text: "FSC & BoM licensing (banking, brokerage, funds, insurance, PSPs, crypto)." },
                            { text: "Residency & investment structuring." },
                            { text: "Compliance & ongoing regulatory reporting." },
                            { text: "Comparative jurisdiction planning (Mauritius vs Cyprus vs Malta vs Seychelles)." }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a Tier-1 financial hub with global recognition?"
                        description="Mauritius offers banking, brokerage, funds, fintech, insurance, and crypto licensing, regulated by FSC & BoM."
                        buttonText="Book a Mauritius Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Mauritius a blacklisted jurisdiction?",
        answer: "No — it is OECD-compliant and FATF-aligned."
    },
    {
        question: "What is a GBC?",
        answer: "A Global Business Company, used for financial services, funds, and DTT benefits."
    },
    {
        question: "Is Mauritius good for forex brokers?",
        answer: "Yes — the Investment Dealer License is highly respected."
    },
    {
        question: "Does Mauritius regulate crypto?",
        answer: "Yes — under the VAITOS Act, making it Tier-1 credible for exchanges & custodians."
    },
    {
        question: "Why choose Mauritius over Seychelles?",
        answer: "Mauritius offers higher recognition, treaty access, and Tier-1 credibility, though setup costs are higher."
    }
];

const testimonialsData = [
    {
        quote: "We licensed our investment fund in Mauritius. Offshore Advisory handled FSC licensing and introduced us to global investors.",
        author: "Michael R.",
        role: "Fund Manager"
    },
    {
        quote: "Mauritius was the right choice for our crypto exchange. Offshore Advisory structured our VASP license under the VAITOS Act.",
        author: "Anna P.",
        role: "Crypto Entrepreneur"
    }
];

